import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PartnerGuard from "./PartnerGuard";
import PartnerLayout from "./PartnerLayout";
import PartnerLogin from "./PartnerLogin";
import PartnerDashboard from "./PartnerDashboard";
import PartnerCars from "./PartnerCars";
import PartnerTestDrives from "./PartnerTestDrives";

const PartnerRoutes = () => (
  <Routes>
    <Route path="login" element={<PartnerLogin />} />
    <Route element={<PartnerGuard />}>
      <Route element={<PartnerLayout />}>
        <Route index element={<PartnerDashboard />} />
        <Route path="cars" element={<PartnerCars />} />
        <Route path="test-drives" element={<PartnerTestDrives />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/partner" replace />} />
  </Routes>
);

export default PartnerRoutes;
